<template>
  <!-- 企业建站 -->
  <div class="enterprise maxWidth">
    <div
      class="enterprise-bannner"
      :style="'background-image:url(' + bannerImg + ')'"
    >
      <div class="enterprise-bannnerBox">
        <span class="edescription">{{ bannerList.alias }}</span>
        <span class="name">{{ bannerList.name }}</span>
        <span class="description">{{ bannerList.description }}</span>
        <button type="button" @click="clickParent">立即咨询</button>
      </div>
    </div>
    <NavAssembly :navList="navList" />
    <!-- 系统类型 -->
    <div class="systemType" id="systemType">
      <div class="systemType-top">
        <span
          >{{ typeList.name }}<img src="../../assets/bigTy.png" alt=""
        /></span>
      </div>
      <div class="systemType-main">
        <div class="systemType-pic">
          <img :src="typeList.img" alt="" />
        </div>
        <div class="systemType-mainTop">
          <div class="systemType-mainTopLeft">
            <div class="mainTopLeftBox">
              <span>{{ typeList.description }}</span>
              <div class="">
                <span>{{ typeList.keywords }}</span>
              </div>
            </div>
            <p>{{ typeList.details }}</p>
          </div>
          <div class="systemType-mainTopRight">
            <button type="button" @click="clickParent">立即咨询</button>
          </div>
        </div>
        <div class="systemType-mainList">
          <div
            class="systemType-mainListBox"
            v-for="(item, index) in typeList.lists"
            :key="index"
          >
            <span>{{ item.name }}</span>
            <div class="">
              <span>{{ item.keywords }}</span>
            </div>
            <p :title="item.description">{{ item.description }}</p>
            <img :src="item.icon" alt="" />
          </div>
        </div>
      </div>
    </div>
    <!-- 建设意义 -->
    <div class="buildSignificance" id="constructionMeaning">
      <div class="buildSignificance-top">
        <img src="../../assets/bigTy1.png" alt="" />
        <span>{{ buildList.name }}</span>
        <p>{{ buildList.description }}</p>
      </div>
      <div class="buildSignificance-main">
        <div
          class="buildSignificance-mainBox"
          v-for="(item, index) in buildList.lists"
          :key="index"
        >
          <div class="buildSignificance-number">
            <img :src="item.num_img" alt="" />
          </div>
          <img :src="item.icon" alt="" />
          <span>{{ item.name }}</span>
          <p>{{ item.description }}</p>
        </div>
      </div>
    </div>
    <!-- 行业方案 -->
    <div class="industryScheme" id="industrySolution">
      <div class="industryScheme-top">
        <img src="../../assets/bigTy.png" alt="" />
        <span>{{ industrySchemeList.name }}</span>
        <p>{{ industrySchemeList.description }}</p>
      </div>
      <div class="industryScheme-main">
        <div
          class="industryScheme-mainBox"
          :style="'background-image:url(' + item.img + ')'"
          v-for="(item, index) in industrySchemeList.lists"
          :key="index"
        >
          <div class="mainBoxItem">
            <div class="heng"></div>
            <span>{{ item.name }}</span>
          </div>
          <div class="mainBoxItem1">
            <span>{{ item.name }}</span>
            <button type="button" @click="clickParent">立即咨询</button>
          </div>
        </div>
      </div>
    </div>
    <ChooseUs :chooseUsList="chooseUsList" />
    <CommonProblem :commonProblemList="commonProblemList" />
    <DeliveryList :deliveryList="deliveryList" />
    <DevelopmentProcess :developmentProcessList="developmentProcessList" />
    <ZXDialog ref="mychild" />
  </div>
</template>

<script>
import NavAssembly from "../../components/NavAssembly.vue";
import ChooseUs from "../../components/ChooseUs.vue";
import CommonProblem from "../../components/CommonProblem.vue";
import DeliveryList from "../../components/DeliveryList.vue";
import DevelopmentProcess from "../../components/DevelopmentProcess.vue";
import ZXDialog from "../../components/ZXDialog.vue";
export default {
  name: "enterprise",
  components: {
    NavAssembly,
    ChooseUs,
    CommonProblem,
    DeliveryList,
    DevelopmentProcess,
    ZXDialog
  },
  metaInfo() {
    //设置浏览器标签页标题
    return {
      meta: [
        {
          name: "description",
          content: this.description
        }
      ]
    };
  },
  data() {
    return {
      description: "",
      bannerList: {},
      bannerImg: "",
      navList: [],
      typeList: {},
      chooseUsList: {},
      commonProblemList: {},
      deliveryList: {},
      developmentProcessList: {},
      buildList: {},
      industrySchemeList: {}
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      this.$axios.get("/index/common/getEnterpriseWebsite").then(res => {
        // console.log(res);
        if (res.status == 200) {
          this.description = res.data.data.description;
          this.bannerList = res.data.data["01"];
          this.bannerImg = res.data.data["01"].banner[0].pic;
          this.navList = res.data.data["02"];
          this.typeList = res.data.data["03"];
          this.buildList = res.data.data["04"];
          this.industrySchemeList = res.data.data["05"];
          this.chooseUsList = res.data.data["06"];
          this.commonProblemList = res.data.data["07"];
          this.deliveryList = res.data.data["08"];
          this.developmentProcessList = res.data.data["09"];
        }
      });
    },
    clickParent() {
      this.$refs.mychild.parentHandleclick();
    }
  }
};
</script>

<style scoped>
.maxWidth {
  max-width: 100%;
}
.enterprise {
  width: 1920px;
  margin: 0 auto;
  margin-top: 70px;
}
.enterprise-bannner {
  height: 737px;
  /* background-image: url("~../../assets/qy-banner.jpg"); */
  background-repeat: no-repeat;
  /* background-size: 100%; */
  position: relative;
}
.enterprise-bannnerBox {
  position: absolute;
  top: 149px;
  left: 311px;
  display: flex;
  flex-direction: column;
}
.enterprise-bannnerBox .edescription {
  font-size: 66px;
  font-family: DIN BlackAlternate;
  font-weight: 600;
  color: rgba(69, 70, 71, 0.3);
  line-height: 76px;
  display: block;
  margin-bottom: 74px;
}
.enterprise-bannnerBox .name {
  font-size: 50px;
  font-family: PingFang SC;
  font-weight: 600;
  color: #00000c;
  display: block;
  margin-bottom: 21px;
}
.enterprise-bannnerBox .description {
  width: 518px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.7);
  line-height: 28px;
  display: block;
  margin-bottom: 100px;
}

.enterprise-bannnerBox button {
  cursor: pointer;
  width: 210px;
  height: 54px;
  background: linear-gradient(0deg, #dc3939, #ff4242);
  box-shadow: 0px 14px 10px 0px rgba(253, 66, 66, 0.2);
  border-radius: 6px 0px 6px 0px;
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ffffff;
}
/* 系统类型 */
#systemType {
  position: relative;
  margin-top: 72px;
}
.systemType-top {
  text-align: center;
  margin-bottom: 59px;
}
.systemType-top span {
  position: relative;
  font-size: 32px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #192537;
}
.systemType-top span img {
  display: block;
  width: 36px;
  height: 36px;
  position: absolute;
  top: -7px;
  left: -7%;
}
.systemType-main {
  height: 500px;
  background: #f6fafb;
  border: 1px solid #ffffff;
  padding-top: 37px;
  position: relative;
}
.systemType-pic {
  position: absolute;
  top: 109px;
  left: 31px;
}
.systemType-pic img {
  display: block;
  width: 315px;
  height: 300px;
}
.systemType-mainTop {
  width: 1280px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  /* text-align: center; */
  align-items: center;
  margin-bottom: 39px;
}
.systemType-mainTopLeft {
  display: flex;
  flex-direction: column;
}

.systemType-mainTopLeft > p {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #595959;
}
.mainTopLeftBox {
  display: flex;
  align-items: center;
  margin-bottom: 17px;
}
.mainTopLeftBox > span {
  font-size: 22px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #00000c;
}
.mainTopLeftBox > div {
  width: fit-content;
  height: 22px;
  background: rgba(255, 66, 66, 0.1);
  border: 1px solid #ff4242;
  border-radius: 6px 0px 6px 0px;
  line-height: 17px;
  text-align: center;
}
.mainTopLeftBox > div span {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #ff4242;
}
.systemType-mainTopRight button {
  width: 100px;
  height: 34px;
  background: linear-gradient(0deg, #dc3939, #ff4242);
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ffffff;
}
.systemType-mainList {
  width: 1280px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}
.systemType-mainListBox {
  width: 305px;
  height: 234px;
  background: #ffffff;
  border: 1px solid #e5e9ea;
  padding: 27px 21px 20px;
  position: relative;
  z-index: 998;
}
.systemType-mainListBox > span {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #192537;
}
.systemType-mainListBox > div {
  width: fit-content;
  white-space: nowrap;
  padding: 0 5px;
  height: 20px;
  background: rgba(255, 66, 66, 0.1);
  text-align: center;
  line-height: 18px;
  margin-top: 13px;
  margin-bottom: 26px;
}
.systemType-mainListBox > div > span {
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #ff4242;
}
.systemType-mainListBox > p {
  width: 261px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #595959;
  line-height: 24px;
  margin-bottom: 30px;
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.systemType-mainListBox > img {
  display: block;
  height: 26px;
}
.buildSignificance-top {
  height: 300px;
  background-image: url("~../../assets/YJ-banner.png");
  background-repeat: no-repeat;
  box-shadow: 0px 14px 10px 0px rgba(253, 66, 66, 0.2);
  position: relative;
  text-align: center;
  padding-top: 94px;
  margin-bottom: 110px;
}
.buildSignificance-top img {
  display: block;
  width: 36px;
  height: 36px;
  position: absolute;
  left: 36.5%;
  top: 84px;
}
.buildSignificance-top span {
  display: block;
  font-size: 42px;
  font-family: PingFang SC;
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 24px;
}
.buildSignificance-top p {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #ffffff;
}
.buildSignificance-main {
  width: 1280px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  margin-bottom: 118px;
}
.buildSignificance-mainBox {
  width: 350px;
  height: 190px;
  padding-top: 31px;

  position: relative;
}
.buildSignificance-mainBox img {
  display: block;
  width: 40px;
  height: 40px;
  margin-bottom: 16px;
}
.buildSignificance-mainBox span {
  display: block;
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #192537;
  margin-bottom: 28px;
}
.buildSignificance-mainBox p {
  width: 340px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #595959;
}
.buildSignificance-number {
  position: absolute;
  top: 0;
  right: 0;
  z-index: -1;
}
.buildSignificance-number img {
  display: block;
  width: 153px;
  height: 190px;
}
.industryScheme {
  height: 744px;
  background: #f6fafb;
  border: 1px solid #ffffff;
  padding-top: 62px;
}
.industryScheme-top {
  position: relative;
  text-align: center;
  display: flex;
  flex-direction: column;
  margin-bottom: 55px;
}
.industryScheme-top img {
  display: block;
  width: 36px;
  height: 36px;
  position: absolute;
  top: -7px;
  left: 39.3%;
}
.industryScheme-top span {
  display: block;
  font-size: 32px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #192537;
  margin-bottom: 14px;
}
.industryScheme-top p {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #454647;
}
.industryScheme-main {
  width: 1280px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
}
.industryScheme-mainBox {
  width: 300px;
  height: 200px;
  background-repeat: no-repeat;
  margin-right: 20px;
  margin-bottom: 20px;
  text-align: center;
  align-items: center;
  cursor: pointer;
}
.industryScheme-mainBox:hover .mainBoxItem1 {
  display: block;
}
.industryScheme-mainBox:hover .mainBoxItem {
  display: none;
}
.industryScheme-mainBox .mainBoxItem {
  display: flex;
  flex-direction: column;
  padding-top: 77px;
}
.industryScheme-mainBox .mainBoxItem .heng {
  margin: 0 auto;
  width: 40px;
  height: 3px;
  background: #df3a3a;
  margin-bottom: 22px;
}

.industryScheme-mainBox .mainBoxItem span {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ffffff;
}
.industryScheme-mainBox .mainBoxItem1 {
  display: flex;
  flex-direction: column;
  padding-top: 77px;
  display: none;
}
.industryScheme-mainBox .mainBoxItem1 span {
  display: block;
  font-size: 26px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ffffff;
  margin-bottom: 14px;
}
.industryScheme-mainBox .mainBoxItem1 button {
  margin: 0 auto;
  width: 100px;
  height: 34px;
  background: linear-gradient(0deg, #dc3939, #ff4242);
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/views/productIntroduction/Enterprise.vue